// 表单项 默认配置
export var defaultSearchConfig = {
  searchText: '查询',
  resetText: '重置',
  expand: true
};

/**
 * 默认的表单配置项目
 */
export var defaultFormProps = {
  labelCol: {
    span: 5
  },
  wrapperCol: {
    span: 16
  }
};

/**
 * 每个form组件的 额外的类名
 */
export var formItemClassName = 'compute_super_form_item';

/**
 * table 组件的 id
 */
export var superTableWarpId = 'super_table_warp_use_to_compute';